import React from "react";
import { OrderController } from "./OrderController";
import { OrderViewModel } from "./OrderViewModel";
import * as feedback from "../../common/Feedback/Feedback";
import * as format from "../../common/FormatFunctions";
import * as log from "../../common/Feedback/Log";

export class OrderProvider extends React.Component {
  constructor(props) {
    super(props);
    this.viewModel = new OrderViewModel();
    this.logger = log;
    this.feedback = feedback;

    console.log(props);
  }

  render() {
    return (
      <OrderController
        viewModel={this.viewModel}
        log={this.logger}
        feedback={this.feedback}
        toggleTopbar={this.props.toggleTopbar}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Orders/OrderProvider.js